import Promise from 'bluebird';
import fetchMeAsync from 'helpers/fetchMeAsync';
import signInAsync from 'helpers/signInAsync';
import { eadminUpdateAsync } from 'helpers/graphql';
import {signoutSuccess, registerSuccess, meInit} from './actions';

export const signoutTask = () => {
  delete localStorage.email;
  delete localStorage.password;
  delete localStorage.isAutoSignIn;
  return signInAsync({
    email: "spop-guest@umac.mo",
    password: "ers@umac",
  })
  .then(() => {
    return fetchMeAsync()
    .then(() => {
      location.replace('#/login');
      return meInit();
    })
  });
}

export const registerTask = (data) => {
  const query = `
    mutation (
      $username: String!
      $email: String!
      $password: String!
      $groupId: String!
      $roleId: String!
      $callbackUrl: String!
    ) {
      registerUser (
        username: $username
        email: $email
        password: $password
        groupId: $groupId
        roleId: $roleId
        callbackUrl: $callbackUrl
      )
    }
  `
  return eadminUpdateAsync(query, data)
  .then(() => {
    return registerSuccess()
  })
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/me/tasks.js
 **/